import type { PurchaseRow } from '@contracts';

/**
 * Tabla de órdenes de compra (desglose del KPI "órdenes de compra").
 * Muestra # orden, proveedor, fecha, estado (con semáforo) y monto en MXN.
 */
export function PurchasesTableWidget({ data }: { data: PurchaseRow[] }) {
  const rows = Array.isArray(data) ? data : [];
  if (!rows.length) {
    return <div className="grid h-full place-items-center text-sm text-slate-400">Sin órdenes</div>;
  }

  const dot = (s?: string) =>
    s === 'critical' ? 'bg-red-500' : s === 'warn' ? 'bg-amber-400' : 'bg-emerald-500';

  const money = (v: number) =>
    v.toLocaleString('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 });

  return (
    <div className="h-full overflow-auto pr-1">
      <table className="w-full text-sm">
        <thead className="sticky top-0 bg-white">
          <tr className="text-[10px] font-bold uppercase tracking-wide text-slate-400">
            <th className="py-1 text-left">Orden</th>
            <th className="py-1 text-left">Proveedor</th>
            <th className="py-1 text-left">Fecha</th>
            <th className="py-1 text-left">Estado</th>
            <th className="py-1 text-right">Monto</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={r.id ?? i} className="border-b border-slate-50 last:border-0 hover:bg-slate-50/60">
              <td className="py-1.5 font-semibold text-slate-700">{r.order}</td>
              <td className="py-1.5 truncate text-slate-600">{r.supplier || '—'}</td>
              <td className="py-1.5 text-slate-500">{r.date}</td>
              <td className="py-1.5">
                <span className="flex items-center gap-1.5">
                  <span className={`h-2 w-2 shrink-0 rounded-full ${dot(r.status)}`} />
                  <span className="text-slate-600">{r.state}</span>
                </span>
              </td>
              <td className="py-1.5 text-right tabular-nums font-semibold text-slate-700">{money(r.amount)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
